module.exports = __webpack_public_path__ + "static/media/400052_01.3c012473.png";